import {createSlice} from "@reduxjs/toolkit";
const initialState = {};
export const borrwedBookSlice = createSlice({
  name: "borrwedBook",
  initialState,
  reducers: {},
});
export const {} = borrwedBookSlice.actions;
export default borrwedBookSlice.reducer;
